module.exports = __webpack_public_path__ + "img/160379.188940de.jpg";